import { Entity } from '@/store/shared/entity'
import DeclareProductList from '../declareproductlist/entity'

export default class DeclareGroup extends Entity<number>{
  //
  sequenceNo: number;
  //PO
  poNumber: string;
  //???
  groupName: string;
  //
  declareCustomsId: number;
  //???
  originalId: number;
  // 产品明细
  productList: Array<DeclareProductList>;

  isCopy: boolean = false;

  editRowIndex: number;

  constructor() {
    super();
    this.productList = new Array<DeclareProductList>();
  }
}